import React from 'react';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import { makeStyles, Tooltip } from '@material-ui/core';
import { BoundingBox, getBoxStyle } from './ocr';

interface FocusBoxTooltipProps {
  bbox: BoundingBox;
}

export default function FocusBoxTooltip(props: FocusBoxTooltipProps) {
  const styles = useFocusBoxTooltipStyles();
  const boxStyle = getBoxStyle(props.bbox);
  return (
    <div className={styles.box} style={boxStyle}>
      <Tooltip
        placement="top"
        open={true}
        title="Possible match"
        classes={{ tooltip: styles.tooltip }}
      >
        <div className={styles.target}></div>
      </Tooltip>
    </div>
  );
}

const useFocusBoxTooltipStyles = makeStyles({
  box: {
    position: 'absolute',
    background: 'rgba(221, 79, 223, 0.1)',
    border: '2px solid #DD4FDF',
    borderRadius: '2px',
    boxSizing: 'border-box',
  },
  tooltip: {
    padding: '0 4px',
    background: '#DD4FDF',
    borderRadius: '2px',
    color: 'white',
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '16px',
    margin: '1px 0',
  },
  target: {
    height: '16px',
  },
});
